<template>
  <div class="container-fluid">
    <div v-if="product" class="row mt-2">
      <div class="col-md-12">
        <div class="mt-3">
          <button type="button" class="btn btn-lg btn-outline-primary" @click="back">
            {{ $t('back') }}
          </button>
        </div>
        <br>
        <b-card
          :title="product.name"
          :img-src="product.image | image('x360')"
          :img-alt="product.name"
          img-top
          tag="article"
        >
          <b-card-text>
            <p class="price-detail-wrap">
              <span v-if="product.discount > 0" class="price h3 text-danger">
                <span class="old">{{ price | currency }}</span>
                <span class="badge badge-danger">-{{ product.discount }}%</span>
                <span class="current">{{ discount | currency }}</span>
              </span>
              <span v-else class="price h3 text-danger">
                <span class="num">{{ price | currency }}</span>
              </span>
            </p>
            <dl v-if="product.print_description" class="item-property">
              <dt>{{ $t('description') }}:</dt>
              <dd><p v-html="product.print_description" /></dd>
            </dl>
            <hr>
            <div class="row">
              <div class="col-sm-12">
                <dl class="param param-inline">
                  <dt>{{ $t('quantity') }}: </dt>
                  <dd>
                    <input v-model.number="quantity" type="number" class="form-control" min="1" max="50">
                  </dd>
                </dl>
              </div>
            </div>
            <hr>
            <button type="button" class="btn btn-lg btn-outline-primary text-uppercase" @click="addToCart(product.id)">
              {{ $t('add_to_cart') }}
            </button>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
export default {
  metaInfo () {
    return {
      title: this.title
    }
  },
  data: () => ({
    product: null,
    quantity: 1,
    modalData: null,
    title: 'Loewe-Zaun.de'
  }),
  computed: {
    ...mapGetters({
      productId: 'category/product',
      products: 'category/products'
    }),
    price () {
      return this.quantity * this.product.price
    },
    discount () {
      const discount = Number.parseFloat(this.product.discount) / 100 * this.price
      let totalDiscount = 0
      totalDiscount = this.price - discount
      return totalDiscount
    }
  },
  mounted () {
    this.getProduct()
  },
  methods: {
    ...mapActions({
      addProduct: 'checkout/addProduct',
      removeItem: 'checkout/removeItem'
    }),
    async getProduct () {
      const apiKey = btoa(process.env.VUE_APP_API_KEY)
      const apiUrl = process.env.VUE_APP_API_URL
      await axios.post(apiUrl + 'product/' + this.productId, { re: apiKey }).then((resp) => {
        this.product = resp.data
      })
    },
    addToCart (id) {
      const qty = this.quantity
      const item = this.products.data.find(p => p.id === id)
      const product = {
        id: item.id,
        images: [{ path: item.image }],
        main_image: item.image,
        multiple: false,
        name: item.name,
        discount: item.discount,
        price: {
          discounted: this.discount * qty,
          total: item.price * qty,
          old_price: item.price,
          delivery: 0
        },
        description: item.print_description,
        quantity: qty
      }
      if (item) {
        this.addProduct(product)
        this.$router.push({ name: 'checkout.cart' })
      }
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
<style>
.discount {
  font-size: 14px;
}
.old {
  color: #999;
  text-decoration: line-through
}
</style>
